import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TrSideMenuComponent } from './tr-side-menu.component';
import { FirstNamePipeModule } from '../../pipes/first-name/fisrt-name.module';
import { TrackingDirectiveModule } from '../../directives/tracking/tracking.module';
import { IfCblcDirectiveModule } from '../../directives/if-cblc/if-cblc.module';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        FirstNamePipeModule,
        IfCblcDirectiveModule,
        TrackingDirectiveModule,
    ],
    exports: [ TrSideMenuComponent ],
    declarations: [ TrSideMenuComponent ],
    entryComponents: [ TrSideMenuComponent ],
})
export class TrSideMenuModule { }
